import { Column } from 'primereact/column'
import { DataTable } from 'primereact/datatable'
import React, { useContext, useEffect, useState } from 'react'

import {
  chart,
  truck1,
  truck2,
  truck3,
  truck4,
  truck5,
  truck6,
  truck7,
} from '../../../utils/images/imagepath'

import {
  avatar1,
  avatar11,
  avatar13,
  avatar17,
  avatar2,
  avatar29,
  avatar30,
} from '../../../utils/images/imagepath'

function CreateCheckList(props: any) {
  const data = props?.data

  const truckDetails = (data: any, index: any) => {
    return (
      <>
        <td>
          <h2 className='table-avatar'>
            <a href='javascript:void(0);' className='avatar avatar-sm me-2'>
              <img
                className='avatar-img rounded-circle'
                src={truck2}
                alt='Profiles'
              />
            </a>
            <a href='javascript:void(0);'>
              {data.model_name} <span>{data.vin_number}</span>
            </a>
          </h2>
        </td>
      </>
    )
  }

  const driverDetails = (data: any, index: any) => {
    return (
      <>
        <td>
          <h2 className='table-avatar'>
            <a href='javascript:void(0);' className='avatar avatar-sm me-2'>
              <img
                className='avatar-img rounded-circle'
                src={avatar1}
                alt='Profiles'
              />
            </a>
            <a href='javascript:void(0);'>
              Cameron Jacob <span>ABC Company</span>
            </a>
          </h2>
        </td>
      </>
    )
  }

  const inspectorDetails = (data: any, index: any) => {
    return (
      <>
        <td>Cameron Jacob</td>
      </>
    )
  }

  const inspectionDate = (data: any, index: any) => {
    return (
      <>
        <td>04-06-2024 10AM</td>
      </>
    )
  }

  const checkList = (data: any, index: any) => {
    return (
      <>
        <td>
          <div className='data-check-list'>
            <ul className='nav'>
              <li>
                <span className='check-list-active'></span>
              </li>
              <li>
                <span className='check-list-active'></span>
              </li>
              <li>
                <span className='check-list-active'></span>
              </li>
              <li>
                <span className='check-list-active'></span>
              </li>
              <li>
                <span className='check-list-active'></span>
              </li>
              <li>
                <span className='check-list-active'></span>
              </li>
            </ul>
            <p>
              28/<span>30</span>
              <a href='javascript:void(0);' className='view-checklist'>
                View Checklist
              </a>
            </p>
          </div>
        </td>
      </>
    )
  }

  const status = (data: any, index: any) => {
    return (
      <>
        <td>
          <span className='badge bg-light-success'>{data.status}</span>
        </td>
      </>
    )
  }

  const action = (data: any, index: any) => {
    return (
      <>
        <td className='table-action'>
          <div className='dropdown'>
            <a
              href='javascript:void(0);'
              className='dropdown-toggle'
              data-bs-toggle='dropdown'
            >
              <i className='feather-more-vertical'></i>
            </a>
            <div className='dropdown-menu dropdown-menu-end'>
              <a href='javascript:void(0);' className='dropdown-item'>
                <i className='feather-eye'></i> View
              </a>
              <a href='javascript:void(0);' className='dropdown-item'>
                <i className='feather-edit'></i> Edit
              </a>
              <a href='javascript:void(0);' className='dropdown-item'>
                <i className='feather-trash-2'></i> Delete
              </a>
            </div>
          </div>
        </td>
      </>
    )
  }

  return (
    <>
      <div className='page-header'>
        <div className='row align-items-center'>
          <div className='col-sm-6'>
            <h3 className='page-title'>Add Checklist</h3>
          </div>
          <div className='col-sm-6'>
            <ul className='breadcrumb'>
              <li className='breadcrumb-item active'>
                <a href='index.html'>Home</a>
              </li>
              <li className='breadcrumb-item'>Check List</li>
            </ul>
          </div>
        </div>
      </div>

      <div className='row'>
        <div className='col-md-12'>
          <div className='checklist-card'>
            <div className='row'>
              <div className='col-md-12'>
                <div className='title-card checklist-card-title'>
                  <h4>Add New Checklist</h4>
                  <p>Please fill below details and create new list</p>
                </div>
              </div>
            </div>
            <div className='row'>
              <form>
                <div className='col-md-12 form-checklist-info mt-3'>
                  <h5>Main Category</h5>
                  <div className='form-checklist mt-3'>
                    <label htmlFor='categoryText' className='form-label'>
                      Category Name <span>*</span>
                    </label>
                    <input
                      type='text'
                      className='form-control'
                      id='categoryText'
                      aria-describedby='categoryText'
                      placeholder='Main Category Name'
                    />
                  </div>
                  <div className='form-checklist mt-3'>
                    <label htmlFor='categoryText' className='form-label'>
                      Category Name <span>*</span>
                    </label>
                    <select
                      id='addedCategory'
                      className='js-states form-control addedCategory'
                    >
                      <option>Engine Compartment</option>
                      <option>Side and Back of Truck</option>
                      <option>Connections and Trailer</option>
                      <option>External Light Check</option>
                      <option>In-Cab with Brake Check</option>
                    </select>
                  </div>
                  <div className='form-checklist mt-3'>
                    <label htmlFor='categorydesc' className='form-label'>
                      Descriptions <span>*</span>
                    </label>
                    <textarea
                      className='form-control'
                      id='categorydesc'
                      rows={3}
                    ></textarea>
                  </div>
                </div>
                <div className='col-md-12 form-checklist-info mt-4'>
                  <h5>Sub Category</h5>
                  <div className='row'>
                    <div className='col-md-6'>
                      <div className='checklist-subcategory'>
                        <p>
                          Sub Category1 <span>*</span>
                        </p>
                        <div className='form-checklist mt-2'>
                          <input
                            type='text'
                            className='form-control'
                            id='categoryText'
                            aria-describedby='categoryText'
                            placeholder='Sub Category Name'
                            value=''
                          />
                        </div>
                        <div className='form-checklist form-subChecklist mt-2'>
                          <label htmlFor='categorydesc' className='form-label'>
                            Descriptions <span>*</span>
                          </label>
                          <textarea
                            className='form-control'
                            id='categorydesc'
                            rows={1}
                            value=''
                          ></textarea>
                        </div>
                      </div>
                    </div>

                    <div className='col-md-6'>
                      <div className='checklist-subcategory'>
                        <p>
                          Sub Category2 <span>*</span>
                        </p>
                        <div className='form-checklist mt-2'>
                          <input
                            type='text'
                            className='form-control'
                            id='categoryText'
                            aria-describedby='categoryText'
                            placeholder='Sub Category Name'
                          />
                        </div>
                        <div className='form-checklist form-subChecklist mt-2'>
                          <label htmlFor='categorydesc' className='form-label'>
                            Descriptions <span>*</span>
                          </label>
                          <textarea
                            className='form-control'
                            id='categorydesc'
                            rows={1}
                          ></textarea>
                        </div>
                      </div>
                    </div>

                    <div className='col-md-6'>
                      <div className='checklist-subcategory'>
                        <p>
                          Sub Category3 <span>*</span>
                        </p>
                        <div className='form-checklist mt-2'>
                          <input
                            type='text'
                            className='form-control'
                            id='categoryText'
                            aria-describedby='categoryText'
                            placeholder='Sub Category Name'
                          />
                        </div>
                        <div className='form-checklist form-subChecklist mt-2'>
                          <label htmlFor='categorydesc' className='form-label'>
                            Descriptions <span>*</span>
                          </label>
                          <textarea
                            className='form-control'
                            id='categorydesc'
                            rows={1}
                          ></textarea>
                        </div>
                      </div>
                    </div>

                    <div className='col-md-6'>
                      <div className='checklist-subcategory'>
                        <p>
                          Sub Category4 <span>*</span>
                        </p>
                        <div className='form-checklist mt-2'>
                          <input
                            type='text'
                            className='form-control'
                            id='categoryText'
                            aria-describedby='categoryText'
                            placeholder='Sub Category Name'
                          />
                        </div>
                        <div className='form-checklist form-subChecklist mt-2'>
                          <label htmlFor='categorydesc' className='form-label'>
                            Descriptions <span>*</span>
                          </label>
                          <textarea
                            className='form-control'
                            id='categorydesc'
                            rows={1}
                          ></textarea>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class='col-md-12 add-subcategory'>
                  <a href='javascript:;' class='add-subcategory-link'>
                    <i class='fa-solid fa-plus'></i> Add Subcategory
                  </a>
                </div>
                <div className='col-md-12 form-btn'>
                  <button type='submit' className='btn create-btn btn-hvr'>
                    Create
                  </button>
                  <button type='submit' className='btn cancel-btn'>
                    Cancel
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
export default CreateCheckList
